export const omitTypename = (key: string, value: any) => (key === '__typename' ? undefined : value)

export const omitTypenameFromObj = <T>(obj: T): T => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  return JSON.parse(JSON.stringify(obj), omitTypename)
}
